<div>
    <div style="display: none;"><div id="chatButton"></div></div>
    <button *ngIf="this.activeProfileService.businessIdentity === 'Bsns.00045852' || this.activeProfileService.businessIdentity === 'Bsns.00000010'" class="nav-link clickableChat btn btn-primary" (click)="launchLiveChat()">
        <i aria-hidden="true" class="fa fa-comment nav-icon"></i>
    </button>
</div>
